import { baseUrl } from 'volto-ebc-radionacional/utils/api';
import { flattenToAppURL } from '@plone/volto/helpers';

export type PreviousContentItem = {
  '@id': string;
  title: string;
  audio?: string | null;
  dateAiring?: string | null;
  image?: any;
  preview_image?: string | null;
  thumbnail?: string | null;
};

export async function getContentPreviousByCurrentContent(
  contentPath: string,
): Promise<PreviousContentItem[]> {
  try {
    const normalizedPath = flattenToAppURL(contentPath || '');
    const url = `${baseUrl}${normalizedPath}/@content-previous`;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(
        `Erro ao buscar conteúdos anteriores: ${response.statusText}`,
      );
    }

    const data = await response.json();
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Falha ao buscar conteúdos anteriores', error);
    return [];
  }
}
